import DemoVaspsTableItem from './DemoVaspsTableItem'

export default DemoVaspsTableItem
